import { languages } from '../../../../libs/languages'

export const initialOfferLink = {
  id: 0,
  offerId: 0,
  lang: `${languages[0].value}`,
  link: '',
}
